import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { App } from 'antd';
import { useStateContext } from '../../../../../contexts/ContextProvider';

export const useProduse = () => {
  const { message } = App.useApp();
  const { token } = useStateContext();
  const [produse, setProduse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  const fetchProduse = useCallback(async (page = 1, pageSize = 10, filters = {}, sort_by = 'data_adaugare', sort_order = 'desc') => {
    if (!token) return;
    
    setLoading(true);
    try {
      const params = {
        token,
        page,
        page_size: pageSize,
        ...filters,
        sort_by,
        sort_order
      };

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/produse`, { params });
      
      setProduse(response.data.items || []);
      setPagination({
        current: page,
        pageSize,
        total: response.data.total || 0
      });
    } catch (error) {
      console.error('Eroare la încărcarea produselor:', error);
      message.error(error.response.data.detail);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const createProdus = useCallback(async (produsData) => {
    if (!token) return false;
    
    try {
      // Separăm datele produsului de datele furnizorului
      const {
        furnizor_mongo_id,
        furnizor_denumire,
        furnizor_brand,
        furnizor_website,
        pret_valoare,
        pret_valuta,
        product_url,
        ...produsCleanData
      } = produsData;

      // Creăm produsul
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/produse`, produsCleanData, {
        params: { token }
      });
      
      const createdProduct = response.data;
      
      // Dacă avem date de furnizor, facem legătura
      if (furnizor_denumire || furnizor_mongo_id || pret_valoare || product_url) {
        try {
          const furnizorLinkData = {
            mysql_id_produs: createdProduct.id,
            mongo_id_furnizor: furnizor_mongo_id || null, // null înseamnă că va crea furnizor nou
            denumire_furnizor: furnizor_denumire || '',
            brand_furnizor: furnizor_brand || '',
            website_furnizor: furnizor_website || '',
            pret: pret_valoare || 0,
            valuta: pret_valuta || 'MDL',
            product_url: product_url || '',
          };

          const furnizorLinkResponse = await axios.post(`${process.env.REACT_APP_API_URL}/produs-furnizor`, furnizorLinkData, {
            params: { token }
          });
          
          message.success('Produsul și furnizorul au fost create și legate cu succes');
          createdProduct.furnizor = furnizorLinkResponse.data;

        } catch (furnizorError) {
          console.error('Eroare la legarea furnizorului:', furnizorError);
          message.warning('Produsul a fost creat, dar a apărut o eroare la legarea furnizorului');
        }
      } else {
        message.success('Produsul a fost creat cu succes');
      }
      
      fetchProduse(pagination.current, pagination.pageSize);
      
      return createdProduct ;
    } catch (error) {
      console.error('Eroare la crearea produsului:', error);
      message.error(error.response.data.detail);
      return false;
    }
  }, [token, pagination, fetchProduse]);

  const updateProdus = useCallback(async (id, produsData) => {
    if (!token) return false;
    
    try {
      // Separăm datele produsului de datele furnizorului
      const {
        furnizor_mongo_id,
        furnizor_denumire,
        furnizor_brand,
        furnizor_website,
        pret_valoare,
        pret_valuta,
        ...produsCleanData
      } = produsData;

      // Actualizăm produsul
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/produse/${id}`, produsCleanData, {
        params: { token }
      });
      
      // Pentru actualizare, nu facem automat legătura cu furnizorul
      // aceasta poate fi gestionată separat
      message.success('Produsul a fost actualizat cu succes');
      fetchProduse(pagination.current, pagination.pageSize);
      return response.data;
    } catch (error) {
      console.error('Eroare la actualizarea produsului:', error);
      message.error(error.response.data.detail);
      return false;
    }
  }, [token, pagination, fetchProduse]);

  const deleteProdus = useCallback(async (id) => {
    if (!token) return false;
    
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/produse/${id}`, {
        params: { token }
      });
      
      message.success('Produsul a fost șters cu succes');
      fetchProduse(pagination.current, pagination.pageSize);
      return true;
    } catch (error) {
      console.error('Eroare la ștergerea produsului:', error);
      message.error(error.response.data.detail);
      return false;
    }
  }, [token, pagination, fetchProduse]);

  const linkFurnizorToProdus = useCallback(async (produsId, furnizorData) => {
    console.log(produsId, furnizorData, "Link");
    if (!token) return false;
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/produs-furnizor?token=${token}`, {
        mysql_id_produs: produsId,
        mongo_id_furnizor: furnizorData._id,
        pret: furnizorData.pret,
        valuta: furnizorData.valuta,
        product_url: furnizorData.product_url || '',
      });
      
      message.success('Furnizorul a fost legat de produs cu succes');
      fetchProduse(pagination.current, pagination.pageSize);
      return response.data;
    } catch (error) {
      console.error('Eroare la legarea furnizorului:', error);
      message.error(error.response.data.detail);
      return false;
    }
  }, [token, pagination, fetchProduse]);

  return {
    produse,
    loading,
    pagination,
    fetchProduse,
    createProdus,
    updateProdus,
    deleteProdus,
    linkFurnizorToProdus
  };
}; 